import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class OrdemService {
    
    async getAll(page = 0, size = 10, sortBy = "id", sortOrder = -1, filter = {}) {

        const order = sortOrder === 1 ? "asc" : "desc";
        var url = `${API_URL}/v1/ordem?page=${page}&size=${size}&sort=${sortBy}&order=${order}`;

        if (filter.inicio) {
            url += `&inicio=${filter.inicio}`;
        }

        if (filter.fim) {
            url += `&fim=${filter.fim}`;
        }

        if (filter.status) {
            url += `&statusList=${filter.status.join(",")}`;
        }

        if (filter.texto) {
            url += `&texto=${encodeURIComponent(filter.texto)}`;
        }

        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async get(id) {
        var url = `${API_URL}/v1/ordem/${id}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getVendaContaAzul(numero) {
        var url = `${API_URL}/v1/ordem/vendacontaazul/${numero}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getPessoaContaAzul(numero) {
        var url = `${API_URL}/v1/ordem/clientecontaazul/${numero}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async anexarDocumento(id, documento) {
        var url = `${API_URL}/v1/ordem/${id}/anexardocumento`;
        return axios.post(url, documento, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async save(ordem) {
        var url = `${API_URL}/v1/ordem`;
        return axios.post(url, ordem, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async delete(id) {
        var url = `${API_URL}/v1/ordem/${id}`;
        return axios.delete(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async deleteAnexo(anexoId) {
        var url = `${API_URL}/v1/ordem/anexo/${anexoId}`;
        return axios.delete(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async cancelarAgenda(agendaId) {
        var url = `${API_URL}/v1/ordem/agendamento/${agendaId}`;
        return axios.delete(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async downloadAnexo(anexoId) {
        var url = `${API_URL}/v1/anexo/${anexoId}/download`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
            responseType: "blob"
        }); 
    }

    async solicitarAnaliseFinanceira(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/solicitaranalisefinanceira`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async solicitarAgendamento(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/solicitaragendamento`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async confirmarPagamentoART(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/confirmarpagamentoart`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async updateItemEntregue(idItem, entregue) {
        var url = `${API_URL}/v1/ordem/venda/item/${idItem}/entregue/${entregue}`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async confirmarPagamento(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/confirmarpagamento`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async confirmarFinalizacaoParecerAcesso(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/confirmarfinalizacaopareceracesso`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async cancelarVendaFotovoltaica(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/cancelarvendafotovoltaica`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async finalizarOrcamento(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/finalizarorcamento`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async finalizarOrcamentoSemPagamento(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/finalizarorcamentosempagamento`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async confirmarPagamentoFotovoltaico(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/confirmarpagamentofotovoltaico`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async finalizarOrdemServico(ordemId, posVenda) {
        var url = `${API_URL}/v1/ordem/${ordemId}/finalizar`;
        return axios.post(url, posVenda, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async reabrirOrdemServico(ordemId, posVenda) {
        var url = `${API_URL}/v1/ordem/${ordemId}/reabrir`;
        return axios.post(url, posVenda, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async solicitarRevisaoDocumentos(ordemId, formRevisao) {
        var url = `${API_URL}/v1/ordem/${ordemId}/solicitardocumento`;
        return axios.post(url, formRevisao, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async confirmarRevisaoDocumentos(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/confirmarrevisaodocumentos`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async downloadAnexoFile(anexoId, nomeArquivo) {
        try {
            const response = await this.downloadAnexo(anexoId);
            const blob = response.data;
            
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo || `anexo_${anexoId}`;
            
            document.body.appendChild(link);
            link.click();
            
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            return blob;
        } catch (error) {
            throw new Error("Erro ao fazer download: " + error.message);
        }
    }

    async visualizarAnexoFile(anexoId, nomeArquivo) {
        try {
            const response = await this.downloadAnexo(anexoId);
            const blob = response.data;
            
            const url = window.URL.createObjectURL(blob);
            const newWindow = window.open(url, '_blank');
            
            if (newWindow) {
                newWindow.document.title = nomeArquivo || `anexo_${anexoId}`;
            } else {
                throw new Error("Não foi possível abrir a nova janela. Verifique se o bloqueador de pop-ups está ativado.");
            }
        } catch (error) {
            throw new Error("Erro ao visualizar o anexo: " + error.message);
        }
    }

    saveAgendamento(ordemId, agendamento) {
        var url = `${API_URL}/v1/ordem/${ordemId}/agendamento`;
        return axios.post(url, agendamento, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    notificarClienteAgenda(agendaId) {
        var url = `${API_URL}/v1/ordem/agendamento/${agendaId}/notificarcliente`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    notificarClienteParecerAcesso(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/notificarcliente/pareceracesso`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    solicitarPagamentoART(ordemId) {
        var url = `${API_URL}/v1/ordem/${ordemId}/solicitarpagamentoart`;
        return axios.post(url, {}, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }
}

export default new OrdemService();

